import * as graphql from '@treams/treams-network';
import { Input } from '@treams/treams-ui';

export default function ConfigurationFieldText(props: {
	field: graphql.ConnectorConfigFieldText;
	autoFocus?: boolean;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => void;
}) {
	return (
		<Input
			small
			autoFocus={props.autoFocus}
			value={props.change?.textValue ?? props.field.text ?? ''}
			onChange={(textValue) => props.onChange({ textValue })}
		/>
	);
}
